import { gql } from "@apollo/client";

export const GET_SKUS = gql`
  query GetSkus(
    $brand: String,
    $model: String,
    $brandName: String,
    $modelName: String,
    $year: Float,
    $cc: Float,
    $minPrice: Float,
    $maxPrice: Float,
    $skuCode: String,
    $status: String,
    $sort: String,
    $searchText: String,
    $page: Float,
    $limit: Float,
  ) {
    getAllSkus(
      brand: $brand
      model: $model
      brandName: $brandName
      modelName: $modelName
      year: $year
      cc: $cc
      minPrice: $minPrice
      maxPrice: $maxPrice
      skuCode: $skuCode
      status: $status
      sort: $sort
      searchText: $searchText
      page: $page
      limit: $limit
    ) {
      count
      pages
      page
      filters {
        models
        years
        cc
        minPrice
        maxPrice
      }
      data {
        _id
        numericId
        brand
        model
        brandName
        brandAbbreviation
        brandNumericId
        modelName
        modelNumericId
        year
        cc
        version
        code
        description
        minPrice
        images {
          url
        }
        status
        createdAt
        updatedAt
      }
    }
  }
`;
